import { render } from "./singleClue.vue?vue&type=template&id=3f154f8e&bindings={\"clueObject\":\"props\",\"direction\":\"props\",\"clueFocus\":\"props\",\"settingsObject\":\"props\",\"clueNum\":\"data\",\"clueKey\":\"options\",\"whichFocus\":\"options\",\"clueClickEar\":\"options\"}"
import script from "./singleClue.vue?vue&type=script&lang=js"
export * from "./singleClue.vue?vue&type=script&lang=js"
script.render = render

export default script